import type { FaireProductEntity } from "../../entity_types/product";

export const p_8335qn2cjd: FaireProductEntity = {
  token: "p_8335qn2cjd",
  type: "product",
  name: "Velvet Jewelry Zip Case / Organizer - Queen of Hearts -White",
  brandToken: "b_489687c2",
  brandName: "Living Royal",
  imageUrl:
    "https://cdn.faire.com/fastly/665e84a0ab256a698f75d82ece7cc0f50a75e54e0b6bcdf6eed0074f1087746a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8da45cafb6bf0de3a2573dbcf2d7d941227a3c446a31fea2bd1e3a28a7eebcd5.webp",
    "https://cdn.faire.com/fastly/900cc8db971b6d449d408fd3c29ad4b1756a17146d3c4838a9c4d423857cc484.jpeg",
    "https://cdn.faire.com/fastly/7b77bebcf95850d74629441c5d7cb1ec832d085ae453b708203625a2f8f5d265.jpeg",
    "https://cdn.faire.com/fastly/cf49b5de72435c7e4bc4fdcf1ff8abe21b76bf2a9635ddd1c5c8ba48a1ca957b.jpeg",
  ],
  priceDollars: 17.12,
  description:
    "Ensure your jewelry stays protected and stylish on the go with Living Royal's Jewelry Zip Cases. This ultimate travel companion is perfectly designed for organizing all types of jewelry, including rings, earrings, necklaces, and bracelets, using multiple hidden slots and compartments to keep your valuables secure. Crafted from luxurious, super soft velvet, each case also includes a built-in mirror for added convenience.\n\nDetails\n*4.5\" Diameter\n*100% Velvet\n\nLiving Royal is your go-to destination for the funkiest spring products on planet Earth. Whether you’re looking for sports-themed gear for the NBA Finals, filling Easter baskets, celebrating Mother’s Day or Father’s Day, or picking out a perfect graduation gift, Living Royal brings the fun!",
  tags: [],
  msrpDollars: 34.23,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:38.129Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
